import {minmax, sectionToFixedMap} from '../shared.js';
import {buildNarrativeTextTimeline} from '../animations.js';

const article = document.querySelector('#chapter10');
const section = article.querySelector('#chapter10-narrative');
const fixed = sectionToFixedMap.get(section);
const timeline = new TimelineLite({paused: true});

const narrativeText = fixed.querySelector('.narrative-text');

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter10:init');

  buildNarrativeTextTimeline(timeline, narrativeText, 85);

  section.addEventListener('scrub', ({detail: {vh}}) => timeline.seek(minmax(0, vh, timeline.duration())));
}
